/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon20Light = forwardRef('MediaAudioWaveIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9 3a.5.5 0 0 0-1 0v14a.5.5 0 0 0 1 0V3Z" }),
        React.createElement("path", { d: "M15 5a.5.5 0 0 0-1 0v10a.5.5 0 0 0 1 0V5Z" }),
        React.createElement("path", { d: "M18 8a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V8Z" }),
        React.createElement("path", { d: "M11.5 7a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M5.5 5.682a.5.5 0 0 1 .5.5v7.636a.5.5 0 0 1-1 0V6.182a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M3 8.75a.5.5 0 0 0-1 0v2.5a.5.5 0 0 0 1 0v-2.5Z" })));
});
